import styled, { StyledProps } from 'styled-components/macro';

export type CellStatusStylesProps = StyledProps<{
}>;

export const CellStatus = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-right: 8px;
  }
`;